import { naarOuder } from '../../../lib/bericht';

/**
 * Utility for posting iframe position/size messages to parent window
 */
export const postToParent = ({
  height = "0px",
  width = "0px",
  top = "",
  right = "0px",
  bottom = "0px",
  left = "",
  floating = "relative",
  redirectUrl = null,
} = {}) => {
  naarOuder(
    {
      reservationIframeHeight: height,
      reservationIframeWidth: width,
      reservationIframePositionTop: top,
      reservationIframePositionRight: right,
      reservationIframePositionBottom: bottom,
      reservationIframePositionLeft: left,
      reservationIframePositionFloating: floating,
      ...(redirectUrl && { redirectUrl }),
    });
};

export const hideIframe = () =>
  postToParent({ height: "0px", width: "0px" });

export const showFullIframe = () =>
  postToParent({ height: "100vh", width: "100%" });
